import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ConfigurationType } from '../../../../domain/consts';
import { Policy } from '../../../../domain/policy.model';
import { SummaryType } from '../../../../domain/product.domain';
import { PolicyState } from '../../store/policy.state';

@Component({
    selector: 'app-policy-card',
    templateUrl: './policy-card.component.html',
    styleUrls: ['./policy-card.component.scss']
})
export class PolicyCardComponent implements OnInit, OnDestroy {

    policies: Policy[];
    subscriptions: Subscription[] = [];
    summaryType = SummaryType;
    configurationTypes = ConfigurationType;

    get policyNumber() {
        return this.policies.map(p => p.number).join(', ');
    }

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(PolicyState.getPolicies).subscribe(policies => this.policies = policies)
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
